import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RewardsService } from '@Services/rewards.service';
import { catchError, map, of } from 'rxjs';

export const rewardsSystemHealtyGuard: CanActivateFn = (_route, _state) => {

  const rewardsService = inject(RewardsService);

  if (rewardsService.rewardSystemError()) {
    return handleRewardsSystemKO();
  }

  return rewardsService.fetchActiveCampaigns().pipe(
    map(() => {
      if (rewardsService.rewardSystemError()) {
        return handleRewardsSystemKO();
      }
      return true;
    }),
    catchError(() => {
      return of(handleRewardsSystemKO());
    })
  );
};

const handleRewardsSystemKO = () => {
  const router = inject(Router);
  return router.createUrlTree(['/']);
}
